'use client';

import { ROUTES } from '@/constants/routes/default';
import Link from 'next/link';
import React from 'react';

const HomepageStartDC = ({ isAuthorized }: { isAuthorized: boolean }) => {
  return (
    <div className="w-full py-20 bg-white">
      <div className="px-4 mx-auto max-w-142">
        <h2 className="mt-5 text-dc-cod-gray font-bold max-md:text-3xl md:text-[40px] md:leading-11 text-center">
          Start with three roles
        </h2>
        <p className="mt-5 text-dc-cod-gray text-center">
          Rank what you want, add your email, and the matches come to you. Two minutes to set up,
          and you can change it whenever.
        </p>
        <Link
          href={isAuthorized ? ROUTES.profile : ROUTES.signup}
          className="mt-5 w-fit mx-auto h-12.5 flex items-center justify-center default-transition px-6 bg-dc-vermilion rounded-lg font-bold text-white hover:bg-dc-rock-spray"
        >
          {isAuthorized ? 'UPDATE YOUR PROFILE' : 'CREATE YOUR PROFILE'}
        </Link>
      </div>
    </div>
  );
};

export default HomepageStartDC;
